import React from 'react'
import Edit from '../../crud/edit'
import Contacts from '../../contacts'

const fields = [
  {
    name: 'Primary Contacts',
    prop: 'primary_contacts',
    type: 'component',
    component: Contacts
  }
]

const EditContacts = ({ params }) => (
  <Edit
// @ts-ignore
    title='Edit Institution Contacts'
    fields={fields}
    apiPath={`admin/institutions/${params.institutionId}`}
    successRedirectPath={`/membership/institutions/${params.institutionId}/edit`}
  />
)

export default EditContacts
